interface MaterialCardProps {
  readonly materialId: string;
  readonly name: string;
  readonly description: string;
  readonly price: number;
  readonly estimatedDays: number;
  readonly onSelect?: (materialId: string) => void;
  readonly isSelected?: boolean;
  readonly disabled?: boolean;
}

export const MaterialCard = ({
  materialId,
  name,
  description,
  price,
  estimatedDays,
  onSelect,
  isSelected = false,
  disabled = false,
}: MaterialCardProps) => {
  return (
    <button
      type="button"
      onClick={() => !disabled && onSelect?.(materialId)}
      disabled={disabled}
      className={`focus-ring material-card ${isSelected ? 'material-card--selected' : ''}`}
      style={{
        borderRadius: 'var(--radius-lg)',
        border: `1px solid ${isSelected ? 'var(--color-primary-500)' : 'var(--border-default)'}`,
        backgroundColor: disabled ? 'var(--bg-surface-sunken)' : isSelected ? 'var(--bg-accent-subtle)' : 'var(--bg-surface)',
        padding: 'var(--space-4)',
        textAlign: 'left',
        cursor: disabled ? 'not-allowed' : 'pointer',
        boxShadow: isSelected ? '0 0 0 2px var(--color-primary-500)' : 'none',
        opacity: disabled ? 0.5 : 1,
        transition: `all var(--duration-fast) var(--ease-out)`,
      }}
    >
      <div className="flex items-start justify-between">
        <h4
          style={{
            fontWeight: 'var(--font-weight-semibold)',
            color: 'var(--text-primary)',
          }}
        >
          {name}
        </h4>
        <span
          style={{
            fontSize: 'var(--text-lg)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--color-primary-600)',
          }}
        >
          ${price.toFixed(2)}
        </span>
      </div>
      <p
        style={{
          marginTop: 'var(--space-1)',
          fontSize: 'var(--text-sm)',
          color: 'var(--text-secondary)',
        }}
      >
        {description}
      </p>
      <p
        style={{
          marginTop: 'var(--space-2)',
          fontSize: 'var(--text-xs)',
          color: 'var(--text-secondary)',
        }}
      >
        Est. {estimatedDays} business day{estimatedDays !== 1 ? 's' : ''}
      </p>
    </button>
  );
};
